
export const statusTagVariants = {
  opened: 'attention',
  closed: 'cancel',
  open: 'attention',
  new: 'attention',
  solved: 'active',
  pending: 'pending',
};

export const ticketStatus = {
  OPEN: 'open',
  CLOSED: 'closed',
  SOLVED: 'solved',
};

export const channelType = {
  NATIVE_MESSAGING: 'native_messaging',
  API: 'api',
  WEB: 'web',
};
